export const toSuggestLocation = (array: number[]): [number, number] => {
  return [array[0], array[1]]
}
